import { defineAction } from '~/prix'
import createQuestionnaireAction from './questionnaireCreate.action.json' with { type: 'json' }
import { z } from 'zod'
import { questionnaireObject } from '../questionnaireObject'

const createQuestionnaireDefinition = defineAction({
  ...createQuestionnaireAction,
  input: questionnaireObject.omit({ id: true }),
  output: z.object({}),
})

export default createQuestionnaireDefinition
